import * as React from "react";
import CONSTS from "../../../consts";
import StoreEvents from "../store-events";
export default class Events extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(StoreEvents, Object.assign({ imgPath: `${CONSTS.STORAGEURL}/${CONSTS.EVENTCONTAINER}/${this.props.supplier.Id}.jpg` }, this.props)));
    }
}
;
//# sourceMappingURL=events.js.map